import axios from 'axios';
import Paths from 'helper/paths';
import { useQueryParams } from 'hooks/useQueryParams';
import { useEffect } from 'react';
import { redirect, useNavigate } from 'react-router';
import { toast } from 'react-toastify';
import urls from 'utils/urls';
import * as S from './verifyEmail.styles';
const VerifyEmail = () => {
  const query = useQueryParams();
  const navigate = useNavigate();
  useEffect(() => {
    verifyEmail();
  }, []);

  const verifyEmail = () => {
    console.log(query.get('token'));
    axios
      .patch(
        urls.verifyEmail,
        {},
        {
          headers: {
            authorization: `Bearer ${query.get('token')}`,
          },
        }
      )
      .then((res) => {
        toast.success('your account is verified');
        navigate(Paths.Login.index().route);
        redirect('/login');
      })
      .catch((err) => {
        navigate(Paths.Signup.index().route);
        toast.error(err.response.data.message);
      });
  };

  return <S.Wrapper>verify Email...</S.Wrapper>;
};

export default VerifyEmail;
